export const addSubtitle = (subtitle) =>
({
	type    : 'ADD_SUBTITLE',
	payload : { subtitle }
});

export const removeSubtitle = (subtitleId) =>
({
	type    : 'REMOVE_SUBTITLE',
	payload : { subtitleId }
});

export const removeAllSubtitles = () =>
({
	type  : 'REMOVE_ALL_SUBTITLES'
});